import { Component, Input } from '@angular/core';
import { Events, NavController, NavParams } from "ionic-angular";
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the AdvertComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'advert',
    templateUrl: 'advert.html'
})
export class AdvertComponent {

    @Input() shopId;

    errors: {};
    loading: boolean;
    adverts: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public events: Events,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        private iab: InAppBrowser) {
        this.shopId = navParams.get('shopId');
        this.adverts = [];
    }

    ngOnInit() {
        this.getAdverts();
    }

    getAdverts() {
        this.loading = true;

        this.http.get(`/teams/${this.shopId}/adverts`)
            .subscribe(adverts => {
                this.adverts = adverts;
                this.loading = false;
            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            })
    }
    
    onBanner(banner) {
        if(banner.url){
            const browserRef = this.iab.create(banner.url, '_blank', 'clearcache=yes,clearsesioncache=yes');
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/advert/advert.ts